import { GoogleLogin } from '@react-oauth/google';
import { useFeedback } from '../feedback/Service';
import { Box } from '@mui/joy';
import { useMediaQuery } from '@mui/material';

const GoogleLoginButton = ({ onSuccess }) => {
  const feedback = useFeedback();
  const handleError = (error) => {
    console.error("Google login error", error);
    feedback.snackbar({ text: "Google login error", type: "error" });
  }
  const isScreenSmall = useMediaQuery('(max-width:600px)');
  return (
    <Box sx={{ maxWidth: '100%', width: "100%" }}>
      <GoogleLogin onSuccess={onSuccess} onError={handleError} useOneTap width={isScreenSmall ? window.innerWidth - 48 : 1000} text="continue_with" size="large" logo_alignment="center" />
    </Box>
  );
}

export default GoogleLoginButton;